import { ENDPOINTS } from '@core/constants/endpoints';
import { map } from 'rxjs/operators';
import { DATE_FORMAT } from '@app/shared/enum/dates';
import { HttpClient } from '@angular/common/http';
import { DateService } from '@app/shared/helpers/date.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Vulnerabilities } from '@app/shared/models/vulnerabilities.model';

@Injectable()
export class VulnerabilitiesService {
    RESOURCE_TYPES = {
        MANUAL: 'manual',
        DOWNLOAD: 'download',
    };

    constructor(private http: HttpClient, private dateService: DateService) {}

    getVulnerabilities(lang: string): Observable<Vulnerabilities> {
        const endpoint = ENDPOINTS.data.vulnerabilities.replace('<lang>', lang);

        return this.http.get(endpoint).pipe(
            map((data: any) => {
                data.active?.sort((a, b) => b.date - a.date);
                data.archived?.sort((a, b) => b.date - a.date);

                /* eslint-disable @typescript-eslint/no-unsafe-return */
                return {
                    lastUpdate: this.dateService.getFormattedDate(
                        data.lastUpdate,
                        DATE_FORMAT.LONG_FULL_DATE
                    ),
                    active:
                        data.active?.map((vulnerability: any) => ({
                            ...vulnerability,
                            date: this.dateService.getFormattedDate(
                                vulnerability.date,
                                DATE_FORMAT.LONG_FULL_DATE
                            ),
                            resources: {
                                manuals: vulnerability.resources.filter(
                                    (resource) => resource.type === this.RESOURCE_TYPES.MANUAL
                                ),
                                download: vulnerability.resources.filter(
                                    (resource) => resource.type === this.RESOURCE_TYPES.DOWNLOAD
                                ),
                            },
                        })) || [],
                    archived:
                        data.archived?.map((vulnerability: any) => ({
                            ...vulnerability,
                            date: this.dateService.getFormattedDate(
                                vulnerability.date,
                                DATE_FORMAT.LONG_FULL_DATE
                            ),
                            resources: {
                                manuals: vulnerability.resources.filter(
                                    (resource) => resource.type === this.RESOURCE_TYPES.MANUAL
                                ),
                                download: vulnerability.resources.filter(
                                    (resource) => resource.type === this.RESOURCE_TYPES.DOWNLOAD
                                ),
                            },
                        })) || [],
                } as Vulnerabilities;
                /* eslint-enable @typescript-eslint/no-unsafe-return */
            })
        );
    }
}
